import React from 'react';
import { useOfflineState } from './useOfflineState';
import { useQuickload } from './useQuickload';
import { TrelloOnline } from 'app/src/components/TrelloOnline';

export const App = () => {
  const wasEverOffline = useOfflineState();
  useQuickload();

  if (wasEverOffline) {
    window.location.href = `/offline?returnUrl=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }

  return <TrelloOnline />;
};
